module.exports = __webpack_public_path__ + "static/img/header.8d10e819.jpeg";